import React from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const ReactDatePicker = ({ selected, onChange, showTimeSelect = false, ...props}) => {
    return (
        <DatePicker {...props} selected={selected} onChange={onChange} showTimeSelect={showTimeSelect} />
    );
}

export default ReactDatePicker